import axios from "@axios";
import * as ep from "./endpoints";

export default class Service {
  static updateFinancialData(payload) {
    var toSend = new FormData();
    for (const key in payload) {
      if (Object.hasOwnProperty.call(payload, key)) {
        const element = payload[key];
        toSend.append(key, element);
      }
    }
    toSend.append("_method", "PUT");
    return axios
      .post(ep.FINANCIAL_DATA_BY_ID(payload.id), toSend)
      .then((res) => res);
  }
  static deleteFinancialData(id) {
    return axios.delete(ep.FINANCIAL_DATA_BY_ID(id)).then((res) => res);
  }
  static addFinancialData(payload) {
    var toSend = new FormData();
    for (const key in payload) {
      if (Object.hasOwnProperty.call(payload, key)) {
        const element = payload[key];
        toSend.append(key, element);
      }
    }
    return axios.post(ep.FINANCIAL_DATA, toSend).then((res) => res);
  }
  static deleteFinancialGrant(id) {
    return axios.delete(ep.FINANCIAL_GRANT_BY_ID(id)).then((res) => res);
  }
  static fetchNationalDonations(id) {
    return axios.get(ep.INTERNATIONAL_DONATIONS_BY_ID(id)).then((res) => res);
  }
}
